<template>
  <div :id="standardCampaignId" class="standard-campaign-detail-area">
    <HeadingThree>{{ title }}</HeadingThree>

    <div v-if="hasBanner" class="standard-campaign-detail-area__banner">
      <a
        v-if="bannerUrl"
        :href="bannerUrl"
        target="_blank"
        class="standard-campaign-detail-area__banner-link"
      >
        <img
          :src="bannerImageUrl"
          :alt="title"
          class="standard-campaign-detail-area__banner-image"
        />
      </a>
      <img
        v-else
        :src="bannerImageUrl"
        :alt="title"
        class="standard-campaign-detail-area__banner-image"
      />
    </div>

    <div v-if="hasEndedAt" class="standard-campaign-detail-area__expiration">
      ※開催期限：{{ formattedEndedAt }}まで
    </div>

    <div
      v-if="hasDescription"
      class="standard-campaign-detail-area__description"
    >
      {{ description }}
    </div>

    <a
      v-if="hasAttention"
      class="standard-campaign-detail-area__attention-link"
      @click="openAttentionModal"
    >
      <AlertCircleOutline />
      <span class="standard-campaign-detail-area__attention-link-text">
        キャンペーン参加時の注意事項
      </span>
    </a>

    <button
      v-if="hasButton"
      class="btn btn--secondary standard-campaign-detail-area__button"
      @click="handleButtonClick"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import HeadingThree from '../../../atoms/headlines/HeadingThree.vue'
import AlertCircleOutline from '../../../atoms/svg_icons/AlertCircleOutline.vue'
import dayjs from 'dayjs'

export default {
  name: 'StandardCampaignDetailArea',
  components: {
    HeadingThree,
    AlertCircleOutline
  },
  props: {
    standardCampaignId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    bannerImageUrl: {
      type: String,
      required: false,
      default: ''
    },
    bannerUrl: {
      type: String,
      required: false,
      default: ''
    },
    endedAt: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    attention: {
      type: String,
      required: false,
      default: ''
    },
    buttonText: {
      type: String,
      required: false,
      default: ''
    },
    buttonUrl: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    hasBanner() {
      return this.bannerImageUrl && this.bannerImageUrl.trim() !== ''
    },
    hasEndedAt() {
      return this.endedAt && dayjs(this.endedAt).isValid()
    },
    formattedEndedAt() {
      if (!this.hasEndedAt) return ''
      return dayjs(this.endedAt).format('YYYY年M月D日 HH:mm')
    },
    hasDescription() {
      return this.description && this.description.trim() !== ''
    },
    hasAttention() {
      return this.attention && this.attention.trim() !== ''
    },
    hasButton() {
      return (
        this.buttonText &&
        this.buttonText.trim() !== '' &&
        this.buttonUrl &&
        this.buttonUrl.trim() !== ''
      )
    }
  },
  methods: {
    openAttentionModal() {
      this.$emit('open-attention-modal', {
        title: this.title,
        attention: this.attention
      })
    },
    handleButtonClick() {
      if (this.buttonUrl) {
        window.open(this.buttonUrl, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.standard-campaign-detail-area {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &__banner {
    &-image {
      object-fit: contain;
      width: 100%;
      height: auto;
    }

    &-link {
      display: block;
      text-decoration: none;
    }
  }

  &__expiration {
    @extend %body;
    color: $gray-1;
  }

  &__description {
    @extend %body;
    white-space: pre-wrap;
  }

  &__attention-link {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    color: $link;

    &-text {
      @extend %body;
      color: $link;
      text-align: center;
      line-height: 1.6;
    }
  }

  &__button {
    width: 100%;
  }
}
</style>
